import { render } from "./404.vue?vue&type=template&id=01cbd5aa&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=01cbd5aa&lang=less"
import "./404.vue?vue&type=style&index=1&id=01cbd5aa&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cbd5aa"]])

export default __exports__